$(document).on('submit', '#add-to-cart-form', function (e) {
  e.preventDefault()
  //TODO: State change when button is pressed
  // When the form is submitted, we want to disable the submit button, select, and show the loader
  // console.log('submit')
  // $('#add-to-cart-button').addClass('x-hidden').removeClass('x-flex')
  // $('#variant-select').addClass('x-hidden').removeClass('x-flex')
  // $('#add-to-cart-loader').addClass('x-flex').removeClass('x-hidden')

  // Serialize the form data
  var formData = $(this).serialize()

  // Convert the serialized data into an object
  var formDataObject = {}
  formData.split('&').forEach(function (item) {
    var parts = item.split('=')
    formDataObject[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1])
  })

  var variant_id = formDataObject['variant_id']

  const cartNotification = document.querySelector('cart-notification')
  cartNotification.addItemToCart(variant_id, 'add')

  // Add a timer to re-enable the submit button, select, and hide the loader after 3 seconds
  // setTimeout(function () {
  //   console.log('timeout')
  //   $('#add-to-cart-button').removeClass('x-hidden').addClass('x-flex')
  //   $('#variant-select').removeClass('x-hidden').addClass('x-flex')
  //   $('#add-to-cart-loader').removeClass('x-flex').addClass('x-hidden')
  // }, 3000)
})
